import { render, staticRenderFns } from "./staging.vue?vue&type=template&id=081d4f8a&"
import script from "./staging.vue?vue&type=script&lang=js&"
export * from "./staging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports